import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import TokenGiris from './pages/TokenGiris';
import BeklemOdasi from './pages/BeklemOdasi';
import HastaAra from './pages/HastaAra';
import HastaDetay from './pages/HastaDetay';
import AnamnezHems from './pages/AnamnezHems';
import Gorevler from './pages/Gorevler';
import GorevlerGiris from './pages/GorevlerGiris';
import HastaLogin from './pages/HastaLogin';
import Layout from './components/Layout';
import './App.css';

function KorunanRoute({ children }) {
  const kullanici = localStorage.getItem('kullanici');
  return kullanici ? children : <Navigate to="/login" replace />;
}

function NormalRoute({ children }) {
  const kullanici = localStorage.getItem('kullanici');
  const tokenGiris = localStorage.getItem('giristipi') === 'token';
  if (!kullanici) return <Navigate to="/login" replace />;
  if (tokenGiris) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
<BrowserRouter basename="/mobil">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/hasta-giris" element={<HastaLogin />} />
        <Route path="/giris" element={<TokenGiris />} />
        <Route path="/" element={<KorunanRoute><Layout /></KorunanRoute>}>
          <Route index element={<Navigate to="/bekleme" replace />} />
          <Route path="bekleme" element={<NormalRoute><BeklemOdasi /></NormalRoute>} />
          <Route path="hasta-ara" element={<NormalRoute><HastaAra /></NormalRoute>} />
          <Route path="hasta/:kayitNo" element={<HastaDetay />} />
          <Route path="hasta/:kayitNo/hemsire-anamnez" element={<AnamnezHems />} />
        </Route>
        <Route path="gorevler-giris" element={<GorevlerGiris />} />
        <Route path="gorevler" element={<KorunanRoute><Gorevler /></KorunanRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
